import { useContext } from 'react';
import { AppBridgeContext } from '../components/AppBridgeProvider';
import { useAppBridge } from '@shopify/app-bridge-react';

/**
 * Safely use App Bridge hook
 * 
 * Tries to get App Bridge instance from:
 * 1. AppBridgeContext (if using createApp directly)
 * 2. useAppBridge hook (if Provider is available)
 * 
 * @returns {Object|null} App Bridge instance or null if not available
 */
export function useSafeAppBridge() {
  // Try to get from context first (our custom setup)
  const appFromContext = useContext(AppBridgeContext);
  
  // Always call useAppBridge hook unconditionally (React Hooks rule)
  // It will return undefined/null if Provider is not set up
  const appFromHook = useAppBridge();

  // Return context value if available, otherwise return hook value (or null)
  return appFromContext || appFromHook || null;
}

